module.exports = __webpack_public_path__ + "img/img-premium_admin_banner.895ae2c4.png";